import { userRequest } from './config'

export const getAccessToken = async (msalInstance) => {
  let result

  result = await msalInstance.acquireTokenSilent(userRequest)

  if (!result) {
    result = await msalInstance.acquireTokenPopup(userRequest)
  }

  if (!result) {
    throw new Error('Could not acquire auth token')
  }

  return result.accessToken
}
